import { FC } from 'react'

import CONFIG from '../../../../config'
import { utils } from '../../../utils'
import { Alert, Text, TextSummary } from '..'

const isChrome: boolean = utils.isBrowserByName('CHROME')

const AlertBrowser = () => {
  return (
    <>
      {!isChrome &&
        <TextSummary className="exam_alert home-alert browser-alert mt-4">

          <div className="row">
            <div className="alert-col-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10.5" stroke="#0098D8" /><path fill-rule="evenodd" clip-rule="evenodd" d="M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z" fill="#0098D8" /><path fill-rule="evenodd" clip-rule="evenodd" d="M11 8C11 7.44772 11.4477 7 12 7H12.01C12.5623 7 13.01 7.44772 13.01 8C13.01 8.55228 12.5623 9 12.01 9H12C11.4477 9 11 8.55228 11 8Z" fill="#0098D8" /></svg></div>
            <div className="alert-col-text">
              {CONFIG.MESSAGE.BROWSER_ALERT}
            </div>
          </div>

        </TextSummary>
      }
    </>
  )
}
export { AlertBrowser }